import { Box, Grid, Pagination, PaginationItem } from "@mui/material";
import CustomCardForCovAppList from "../CustomComponents/CustomCardForCovAppList";
import CustomLosCard from "../CustomComponents/CustomLosCard";
import bank from "../../images/bnk.png";
import { useEffect, useState } from "react";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CovReducerAction } from "../Store/Cov/CovReducer";

const CovApplicationList = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const rowsPerPage = 4;
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [page, setPage] = useState(1);
  const appList = useSelector(
    (state) => state.cov.filterScreen.applicationList
  );
  useEffect(() => {
    setRows(appList.slice(0, rowsPerPage));
    setTotalPageCount(Number(Number((appList.length / 4).toFixed())));
    setTotalRowsCount(appList.length);
  }, [appList]);
  const handlePageChange = (event, newPage) => {
    let offset = (newPage - 1) * rowsPerPage;
    setPage(newPage);
    setRows(appList.slice(offset, offset + rowsPerPage));
  };
  const cardOnClickHandler = (id) => {
    dispatch(CovReducerAction.updateselectedFileNumber(id));
    localStorage.setItem("appNum", id);
    navigate("/stlap/home/CovScreenDashboard");
  };
  return (
    <Box sx={{ margin: "8px !important" }}>
      <Grid container rowSpacing={2} columnSpacing={1}>
        {rows.map((row) => {
          let disDate = row.disbursementList.length - 1;
          return row.disbursementList.length === 0 ? (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={4}>
              <CustomLosCard
                onClick={() => {
                  cardOnClickHandler(row.applicationNum);
                }}
                imgSrc={bank}
                applicantName={row.losCustomer.customerName}
                locality={"Chennai"}
                applicationNum={row.applicationNum}
                sanctionedDate={new Date(
                  row.losCustomer.applicationDate
                ).toLocaleDateString("fr-FR")}
                sanctionAmt={parseInt(
                  row.losCustomer.sanctionAmt
                ).toLocaleString("en-IN")}
                status={row.losCustomer.losStatus}
              />
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={4}>
              <CustomCardForCovAppList
                onClick={() => {
                  cardOnClickHandler(row.applicationNum);
                }}
                imgSrc={bank}
                applicantName={row.losCustomer.customerName}
                locality={"Chennai"}
                applicationNum={row.applicationNum}
                dateOfDisb={new Date(
                  row.disbursementList[disDate].dateOfDisb
                ).toLocaleDateString("fr-FR")}
                disbAmt={parseInt(
                  row.disbursementList[disDate].earlierDisbAmt +
                    row.disbursementList[disDate].disbAmt
                ).toLocaleString("en-IN")}
                status={row.disbursementList[disDate].requestStatus}
              />
            </Grid>
          );
        })}
      </Grid>
      {appList.length !== 0 && (
        <Box
          sx={{
            marginTop: "18px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Pagination
            count={totalPageCount}
            color="primary"
            onChange={handlePageChange}
            page={page}
            renderItem={(item) => (
              <PaginationItem
                slots={{ previous: ArrowBack, next: ArrowForward }}
                {...item}
              />
            )}
          />
        </Box>
      )}
    </Box>
  );
};
export default CovApplicationList;
